import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { AppMaterialModule } from '@emm/app-material.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ConfirmRestorePinsDialogComponent } from './dialogs/confirm-restore-pins-dialog/confirm-restore-pins-dialog/confirm-restore-pins-dialog.component';
import { FileUploadDialogComponent } from './dialogs/file-upload-dialog/file-upload-dialog.component';
import { DeleteConsumerDialogComponent } from './dialogs/delete-consumer-dialog/delete-consumer-dialog.component';
import { DuplicateItemDialogComponent } from './dialogs/duplicate-item-dialog/duplicate-item-dialog.component';
import { AddSubmenuDialogComponent } from './dialogs/add-submenu-dialog/add-submenu-dialog.component';
import { DynamicMenuFormFieldComponent } from './components/dynamic-form-field/dynamic-menu-form-field/dynamic-menu-form-field.component';
import { DynamicManagementFormFieldComponent } from './components/dynamic-form-field/dynamic-management-form-field/dynamic-management-form-field.component';
import { DynamicMenuFormComponent } from './components/dynamic-form/dynamic-menu-form/dynamic-menu-form.component';
import { ViewOverridesDialogComponent } from './dialogs/view-overrides-dialog/view-overrides-dialog.component';
import { CfaDataTableModule } from '@emm/core/modules/cfa-data-table/cfa-data-table-module';
import { AddAttributeGroupDialogComponent } from './dialogs/add-attribute-group-dialog/add-attribute-group-dialog.component';
import { DeleteAttributeGroupDialogComponent } from './dialogs/delete-attribute-group-dialog/delete-attribute-group-dialog.component';
import {RouterModule} from '@angular/router';
import {MatBadgeModule} from '@angular/material/badge';
import {CoreModule} from '@emm/core/core.module';
import {ConfirmMenuDeactivateGuard} from '@emm/shared/guards/confirm-menu-deactivate.guard';
import {OktaAuthGuard} from '@okta/okta-angular';
import {ItemDataService} from '@emm/common-items/services/item-data.service';
import {AddAttributeDialogComponent} from '@emm/shared/dialogs/add-attribute-dialog/add-attribute-dialog.component';
import {
    AddChildLocationDialogComponent
} from '@emm/shared/dialogs/add-child-location-dialog/add-child-location-dialog.component';
import {
    AddConsumerCategoryDialogComponent
} from '@emm/shared/dialogs/add-consumer-category-dialog/add-consumer-category-dialog.component';
import {
    AddConsumerTypeDialogComponent
} from '@emm/shared/dialogs/add-consumer-type-dialog/add-consumer-type-dialog.component';
import {
    AddLockItemDialogComponent
} from '@emm/shared/dialogs/add-emergency-item-dialog/add-lock-item-dialog.component';
import {AddItemDialogComponent} from '@emm/shared/dialogs/add-item-dialog/add-item-dialog.component';
import {
    AddItemToMenuDialogComponent
} from '@emm/shared/dialogs/add-item-to-menu-dialog/add-item-to-menu-dialog.component';
import {AddItemTypeDialogComponent} from '@emm/shared/dialogs/add-item-type-dialog/add-item-type-dialog.component';
import {
    AddLocationSetDialogComponent
} from '@emm/shared/dialogs/add-location-set-dialog/add-location-set-dialog.component';
import {
    AddLocationSetTypeDialogComponent
} from '@emm/shared/dialogs/add-location-set-type-dialog/add-location-set-type-dialog.component';
import {
    AddPinOverridesDialogComponent
} from '@emm/shared/dialogs/add-pin-overrides-dialog/add-pin-overrides-dialog.component';
import {AddRevotesDialogComponent} from '@emm/shared/dialogs/add-revotes-dialog/add-revotes-dialog.component';
import {AppInfoComponent} from '@emm/shared/components/app-info/app-info.component';
import {ChangeSetComponent} from '@emm/shared/components/change-set/change-set.component';
import {ChangeSetsDialogComponent} from '@emm/shared/dialogs/change-sets-dialog/change-sets-dialog.component';
import {ChangeComponent} from '@emm/shared/components/change/change.component';
import {DeleteItemDialogComponent} from '@emm/shared/dialogs/delete-item-dialog/delete-item-dialog.component';
import {
    DeleteChildItemDialogComponent
} from '@emm/shared/dialogs/delete-child-item-dialog/delete-child-item-dialog.component';
import {
    DuplicateConsumerDialogComponent
} from '@emm/shared/dialogs/duplicate-consumer-dialog/duplicate-consumer-dialog.component';
import {
    EditConsumerAttributesDialogComponent
} from '@emm/shared/dialogs/edit-consumer-attributes-dialog/edit-consumer-attributes-dialog.component';
import {EditLocationDialogComponent} from '@emm/shared/dialogs/edit-location-dialog/edit-location-dialog.component';
import {
    EffectiveDateSelectionComponent
} from '@emm/shared/components/effective-date-selection/effective-date-selection.component';
import {LanguageDialogComponent} from '@emm/shared/dialogs/language-dialog/language-dialog.component';
import {LanguageFormComponent} from '@emm/shared/components/language-form/language-form.component';
import {
    LocationSetTypePickerComponent
} from '@emm/shared/components/location-set-type-picker/location-set-type-picker.component';
import {LocationSetPickerComponent} from '@emm/shared/components/location-set-picker/location-set-picker.component';
import {
    LocationsSearchFieldComponent
} from '@emm/shared/components/locations-search-field/locations-search-field.component';
import {
    PasteChildItemDialogComponent
} from '@emm/shared/dialogs/paste-child-item-dialog/paste-child-item-dialog.component';
import {ScopePickerComponent} from '@emm/shared/components/scope-picker/scope-picker.component';
import {ScreenSelectorComponent} from '@emm/shared/components/screen-selector/screen-selector.component';
import {
    UpdateCascadeItemDialogComponent
} from '@emm/shared/dialogs/update-cascade-item-dialog/update-cascade-item-dialog.component';
import {UpdateItemDialogComponent} from '@emm/shared/dialogs/update-item-dialog/update-item-dialog.component';
import {LanguageGlobalIconComponent} from '@emm/shared/components/language-global-icon/language-global-icon.component';
import {CamelCaseToSentenceCasePipe} from '@emm/shared/pipes/camel-case-to-sentence-case.pipe';
import {
    FormlyHorizontalWrapperComponent
} from '@emm/shared/formly/formly-horizontal-wrapper/formly-horizontal-wrapper.component';
import {LanguageDialogIconComponent} from '@emm/shared/components/language-dialog-icon/language-dialog-icon.component';
import {MatConfirmDialogComponent} from '@emm/shared/dialogs/mat-confirm-dialog/mat-confirm-dialog.component';
import {AddConsumerDialogComponent} from '@emm/shared/dialogs/add-consumer-dialog/add-consumer-dialog.component';
import {ProgressBarComponent} from '@emm/shared/components/progress-bar/progress-bar.component';
import {LocalesSelectComponent} from '@emm/shared/components/locales-select/locales-select.component';
import {LegendItemsComponent} from '@emm/shared/components/legend-items/legend-items.component';
import {IconComponent} from '@emm/shared/components/icon/icon.component';
import {sharedReducers, sharedFeatureKey} from '@emm/shared/store/shared.reducer';
import {SharedEffects} from '@emm/shared/store/shared.effects';
import { PublishMenusConfirmationDialogComponent } from './dialogs/publish-menus-confirmation-dialog/publish-menus-confirmation-dialog.component';
import { RemoveItemDialogComponent } from './dialogs/remove-item-dialog/remove-item-dialog.component';
import { DragAndDropFileUploadComponent } from './dialogs/drag-and-drop-file-upload/drag-and-drop-file-upload.component';
import {MatRadioButton} from '@angular/material/radio';
import {MatFormField} from '@angular/material/form-field';
import {AddOptionDialogComponent} from '@emm/shared/dialogs/add-option-dialog/add-option-dialog.component';
import {
    DynamicManagementFormComponent
} from '@emm/shared/components/dynamic-form/dynamic-management-form/dynamic-management-form.component';
import {
    RemoveChildLocationDialogComponent
} from '@emm/shared/dialogs/remove-child-location-dialog/remove-child-location-dialog.component';

@NgModule({
    declarations: [
        ConfirmRestorePinsDialogComponent,
        FileUploadDialogComponent,
        DeleteConsumerDialogComponent,
        DuplicateItemDialogComponent,
        AddSubmenuDialogComponent,
        DynamicMenuFormFieldComponent,
        DynamicManagementFormFieldComponent,
        DynamicMenuFormComponent,
        DynamicManagementFormComponent,
        ViewOverridesDialogComponent,
        AddAttributeGroupDialogComponent,
        DeleteAttributeGroupDialogComponent,
        AddAttributeDialogComponent,
        AddChildLocationDialogComponent,
        RemoveChildLocationDialogComponent,
        AddConsumerCategoryDialogComponent,
        AddConsumerTypeDialogComponent,
        AddLockItemDialogComponent,
        AddItemDialogComponent,
        AddItemToMenuDialogComponent,
        AddItemTypeDialogComponent,
        AddLocationSetDialogComponent,
        AddLocationSetTypeDialogComponent,
        AddPinOverridesDialogComponent,
        AddRevotesDialogComponent,
        AppInfoComponent,
        ChangeSetComponent,
        ChangeSetsDialogComponent,
        ChangeComponent,
        DeleteItemDialogComponent,
        DeleteChildItemDialogComponent,
        DuplicateConsumerDialogComponent,
        EditConsumerAttributesDialogComponent,
        EditLocationDialogComponent,
        EffectiveDateSelectionComponent,
        LanguageDialogComponent,
        LanguageFormComponent,
        LocationSetTypePickerComponent,
        LocationSetPickerComponent,
        LocationsSearchFieldComponent,
        PasteChildItemDialogComponent,
        ScopePickerComponent,
        ScreenSelectorComponent,
        UpdateCascadeItemDialogComponent,
        UpdateItemDialogComponent,
        AppInfoComponent,
        LanguageGlobalIconComponent,
        CamelCaseToSentenceCasePipe,
        FormlyHorizontalWrapperComponent,
        LanguageDialogIconComponent,
        MatConfirmDialogComponent,
        AddConsumerDialogComponent,
        ProgressBarComponent,
        LocalesSelectComponent,
        LegendItemsComponent,
        IconComponent,
        PublishMenusConfirmationDialogComponent,
        RemoveItemDialogComponent,
        DragAndDropFileUploadComponent,
        AddOptionDialogComponent,
    ],
    imports: [
        AppMaterialModule,
        CfaDataTableModule,
        CommonModule,
        FormlyModule,
        ReactiveFormsModule,
        FormsModule,
        StoreModule.forFeature(sharedFeatureKey, sharedReducers),
        EffectsModule.forFeature(SharedEffects),
        DragDropModule,
        CfaDataTableModule,
        RouterModule,
        MatBadgeModule,
        CoreModule,
        MatRadioButton,
        MatFormField,
        NgOptimizedImage
    ],
    exports: [
        AppMaterialModule,
        CommonModule,
        ContextMenuModule,
        FormlyMaterialModule,
        FormlyModule,
        FormsModule,
        ReactiveFormsModule,
        TreeModule,
        DynamicMenuFormComponent,
        DynamicManagementFormComponent,
        FormlyHorizontalWrapperComponent,
        LocationsSearchFieldComponent,
        ProgressBarComponent,
        ScreenSelectorComponent,
        EffectiveDateSelectionComponent,
        LocationSetPickerComponent,
        LocationSetTypePickerComponent,
        ChangeComponent,
        ScopePickerComponent,
        LocalesSelectComponent,
        AppInfoComponent,
        LegendItemsComponent,
        IconComponent,
    ],
    providers: [
        ConfirmMenuDeactivateGuard,
        OktaAuthGuard,
        ItemDataService
    ]
})
export class SharedModule { }
